import React from "react";
import AutoTyping from "react-auto-typing";
import "./ourApproach.css";

const OurApproach = () => {
  return (
    <div className="about-approach-wrapper">
      <div className="section-title">
        <h1 className="title">
          Agile, Collaborative, Transparent, Time-tested.
        </h1>
        <span className="subtitle" aria-hidden="true">
          <AutoTyping
            active // <boolean>
            textRef={"Approach"}
            writeSpeed={150} // <number>
            deleteSpeed={150} // <number>
            delayToWrite={1000} // <number>
            delayToDelete={2000}
          />
        </span>
      </div>
      <div className="about-approach-container">
        <div className="about-approach-box">
          <div className="about-approach-detail first">
            <div className="arrow"></div>
            <h4>Explore</h4>
            <p>
              At Soori Technologies, we work closely with you to uncover the
              ideal software solutions that drive your business forward.
            </p>
          </div>
        </div>
        <div className="about-approach-box">
          <div className="about-approach-detail second">
            <div className="arrow"></div>
            <h4>Create</h4>
            <p>
              We design visually engaging and intuitive interfaces that enhance
              user experience and reflect your brand’s identity.
            </p>
          </div>
        </div>
        <div className="about-approach-box">
          <div className="about-approach-detail third">
            <div className="arrow"></div>
            <h4>Build</h4>
            <p>
              Our skilled developers write secure, high-performance code
              tailored to your specifications, ensuring seamless functionality
              across platforms.
            </p>
          </div>
        </div>
        <div className="about-approach-box">
          <div className="about-approach-detail forth">
            <div className="arrow"></div>
            <h4>Launch</h4>
            <p>
              We ensure a smooth deployment process, getting your product to
              users efficiently for immediate impact and engagement.
            </p>
          </div>
        </div>
        <div className="about-approach-box">
          <div className="about-approach-detail fifth">
            <div className="arrow"></div>
            <h4>Support</h4>
            <p>
              Our flexible maintenance contracts keep your software in top
              condition, enabling quick responses to your evolving needs.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurApproach;
